{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "Новое сообщение",
  "chat.scrollToBottom": "Прокрутка вниз",
  "messagefeedback.thumbDown": "Плохой ответ",
  "messagefeedback.thumbUp": "Хороший ответ",
  "promptfield.aiDisclaimer": "Ответы генерируются с помощью ИИ и могут быть неточными. Проверьте перед использованием.",
  "promptfield.aiUserGuidlines": "Руководство пользователя AI",
  "promptfield.attachments": "Вложения",
  "promptfield.insertButton": "Добавить",
  "promptfield.label": "Запрос",
  "promptfield.placeholder": "Готовы начать работу? Задайте вопрос, поделитесь идеей или добавьте задачу.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.stopButton": "Остановить",
  "promptfield.submitButton": "Отправить",
  "promptfield.uploading": "Отправка",
  "responsestatus.loading": "Загрузка",
  "responsestatus.processing": "Processing...",
  "voicebutton.startListening": "Начать запись",
  "voicebutton.stopListening": "Остановить запись",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
